// @flow

import 'whatwg-fetch'
import { EDITOR_API_URL } from '../urls'
import { baseOptions } from '.'
import { baseFetch } from './index'

export const buckets = {
  banner: 'banner',
  rankingToolOptions: 'rankingToolOptions',
}

export async function uploadToBucket(
  bucket: string,
  file: string,
  description: string = '',
  dynamicUrl: string = 'false'
) {
  const data = new FormData()
  data.append('image', file)
  data.append('description', description)
  data.append('dynamicUrl', dynamicUrl) // Generate the URL in the Google Image API format - editor #480

  const response = await baseFetch(`${EDITOR_API_URL}/v2/images/${bucket}`, {
    ...baseOptions,
    method: 'POST',
    body: data,
  })

  const json = await response.json()

  if (response.status !== 200 && response.status !== 201) {
    let error = response.status
    if (json && json.errors) {
      error += ': ' + json.errors.join()
    }
    throw new Error(error)
  }

  return json
}



// WEBPACK FOOTER //
// ./src/fetch/upload.js